import React from 'react';
import { IconSvgProps } from '@models/common';

const AiChat: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.5124 4.30463H5.28013C4.45174 4.30463 3.78018 4.97615 3.78013 5.80454L3.77935 20.1341C3.77933 20.5406 4.2386 20.7772 4.56959 20.5412L9.09892 17.3123C9.18364 17.2519 9.2851 17.2194 9.38916 17.2194H18.8168C19.6452 17.2194 20.3168 16.5479 20.3168 15.7194V11.5674'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M17.7822 1.49863C17.8791 1.23678 18.2499 1.23678 18.3468 1.49863L19.3171 4.12101C19.3322 4.16171 19.3558 4.19867 19.3865 4.22937C19.4171 4.26008 19.454 4.28379 19.4947 4.29889L22.1174 5.26923C22.3792 5.36614 22.3792 5.73694 22.1174 5.83385L19.495 6.80419C19.4543 6.81922 19.4174 6.84287 19.3867 6.87352C19.356 6.90417 19.3322 6.9411 19.3171 6.98176L18.3468 9.60415C18.2499 9.86629 17.8791 9.86629 17.7822 9.60415L16.8119 6.98207C16.7968 6.94137 16.7732 6.90441 16.7425 6.8737C16.7119 6.843 16.675 6.81929 16.6343 6.80419L14.0116 5.83385C13.7498 5.73694 13.7498 5.36614 14.0116 5.26923L16.634 4.29889C16.6747 4.28386 16.7116 4.26021 16.7423 4.22956C16.773 4.19891 16.7968 4.16198 16.8119 4.12131L17.7822 1.49863Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default AiChat;
